export const IFrameActions = {
  NAVIGATION: 'NAVIGATION',
  REFRESH: 'REFRESH',
  MAP_USER: 'MAP_USER',
}
